import { createContext, useContext } from "react";

export interface DetailProps {
  id: string,
  detail: string,
  label: string
}

export interface DetailProviderProps extends DetailProps {
  children: React.ReactNode
}

export const useDetailInfo = () => useContext(DetailContext)
export const DetailContext = createContext<DetailProps | null>(null)

const DetailInfoProvider = ({children, ...props}: DetailProviderProps) => {
  return <DetailContext.Provider value={props}>
    {children}
  </DetailContext.Provider>
}

export default DetailInfoProvider
